export default "__VITE_ASSET__PFXcTDoj__"